"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var initEvent = function initEvent() {
  return {
    type: undefined,
    eventTypes: new Set(),
    webPageDetails: undefined,
    webInteraction: undefined,
    productListItems: [],
    commerce: undefined,
    search: undefined,
    media: undefined
  };
};
var _default = exports["default"] = initEvent;